import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CircularProgress,
  Stack,
  Typography
} from "@mui/material";
import { BIBlue } from "../../assets/helpers";
import { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import User_Default_Pic from "../../assets/images/avtar_placeholder.jpeg";
import SuggestionSkeleton from "./SuggestionSkeleton";
import { Getrequestcall } from "../../request/Getrequest";
import { FETCH_USER_SUGGETION_LIST, INVITEFRIENDSBYEMAIL } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import { Postrequestcall } from "../../request/Postrequest";

const UserSuggestion = memo(function UserSuggestion({ data }) {
  const navigate = useNavigate();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);

  const {
    TEXT_SEE_ALL = English?.Profile?.TEXT_SEE_ALL,
    TEXT_NO_MAIN_TRADE = English?.Profile?.TEXT_NO_MAIN_TRADE,
    TEXT_DELETE_CONTACT = English?.Profile?.TEXT_DELETE_CONTACT,
    BUTTON_CONNECT = English?.Profile?.BUTTON_CONNECT,
    BUTTON_REQUESTED = English?.Profile?.BUTTON_REQUESTED,
    TEXT_REQUESTED_CONNECT_WITH_YOU = English?.Profile?.TEXT_REQUESTED_CONNECT_WITH_YOU,
    TEXT_CONNECT_REQUEST = English?.Profile?.TEXT_CONNECT_REQUEST,
    TEXT_CONTACT_SUGGETION = English?.Profile?.TEXT_CONTACT_SUGGETION
  } = multiLanguageData?.Profile || {};

  const [suggestionData, setSuggestionData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingButtons, setLoadingButtons] = useState([]);

  useEffect(() => {
    getSuggestions();
  }, []);

  const getSuggestions = async () => {
    try {
      setIsLoading(true);
      const response = await Getrequestcall(
        `${FETCH_USER_SUGGETION_LIST}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      const data = response?.data?.data || [];
      if (data) {
        setSuggestionData(data);
      }
    } catch (error) {
      console.error("getSuggestions-> Error fetching suggestions: ", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddContact = async (data, index) => {
    try {
      setLoadingButtons((prev) => [...prev, index]);

      let obj = {
        UserId: Number(loginData?.userInformation?.UserId),
        FriendsEmails: data !== undefined ? data?.contactEmail : loginData?.userInformation?.Email,
        Notification: {
          ActionUrl: `${import.meta.env.REACT_APP_CONTACTPROFILE}${Number(
            loginData?.userInformation?.UserId
          )}`,
          title: TEXT_CONNECT_REQUEST,
          Body: TEXT_REQUESTED_CONNECT_WITH_YOU
        }
      };

      const response = await Postrequestcall(INVITEFRIENDSBYEMAIL, obj, loginData?.accessToken);

      if (response?.data?.data === "Connect Request Send") {
        const updatedSuggestions = suggestionData.map((item) =>
          item.contactEmail === data?.contactEmail
            ? { ...item, contactStatus: "Request Sent" }
            : item
        );
        setSuggestionData(updatedSuggestions);
      }
    } catch (error) {
      console.log("handleAddContact-> Error When Trying To Add Contact: ", error);
    } finally {
      // Remove specific index from loading buttons array
      setLoadingButtons((prev) => prev.filter((loadingIndex) => loadingIndex !== index));
    }
  };

  const ContactCard = ({ contact, index }) => {
    const handleCardClick = (e) => {
      e.preventDefault();
      navigate(`/${contact?.userId}`);
    };

    const handleConnectClick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      handleAddContact(contact, index);
    };
    return (
      <div>
        <Card
          sx={{
            width: "150px !important",
            height: 250,
            boxShadow: "none",
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            component: "div"
          }}
          key={index}>
          <Box
            sx={{
              height: "100%",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: 3,
                backgroundColor: "grey.100"
              }
            }}
            onClick={handleCardClick}>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Avatar
                src={contact?.contactPictureUrl}
                alt={`${contact?.firstName} ${contact?.lastName} Profile Picture`}
                sx={{ width: 80, height: 80, borderRadius: "50%", objectFit: "cover" }}
                onError={(e) => (e.target.src = User_Default_Pic)}
              />
            </Box>
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
                pt: 2,
                pb: 1
              }}>
              <Typography gutterBottom variant="body2" component="div">
                {contact?.contactName ?? ""}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {contact?.tradeName === "" ? TEXT_NO_MAIN_TRADE : contact?.tradeName}
              </Typography>
            </CardContent>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              {contact.contactStatus === "No" ? (
                <Button
                  size="small"
                  sx={{
                    backgroundColor: loadingButtons.includes(index) ? "" : BIBlue,
                    color: "white"
                  }}
                  disabled={loadingButtons.includes(index)}
                  onClick={handleConnectClick}>
                  {" "}
                  {loadingButtons.includes(index) ? <CircularProgress size={24} /> : BUTTON_CONNECT}
                </Button>
              ) : contact.contactStatus === "Request Sent" ? (
                <Button
                  sx={{ backgroundColor: BIBlue, color: "white" }}
                  onClick={(e) => e.stopPropagation()}>
                  {BUTTON_REQUESTED}
                </Button>
              ) : (
                <Button
                  onClick={(e) => e.stopPropagation()}
                  sx={{ backgroundColor: BIBlue, color: "white" }}>
                  {TEXT_DELETE_CONTACT}
                </Button>
              )}
            </Box>
          </Box>
        </Card>
      </div>
    );
  };

  return (
    <Card className="pagelist-content" key={data?.id}>
      <Box sx={{ p: 2 }}>
        {isLoading ? (
          <SuggestionSkeleton />
        ) : (
          <Stack>
            <Stack
              mb={1}
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Typography fontWeight={600}>{TEXT_CONTACT_SUGGETION}</Typography>
              <Button onClick={() => navigate("/contacts")}>{TEXT_SEE_ALL}</Button>
            </Stack>
            <Box sx={{ p: 2, overflow: "scroll", scrollbarWidth: "none" }}>
              <Stack sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                {suggestionData?.map((data, index) => (
                  <ContactCard contact={data} index={index} />
                ))}
              </Stack>
            </Box>
          </Stack>
        )}
      </Box>
    </Card>
  );
});

export default UserSuggestion;
